import React from 'react'
import './AMCPAPLLC.css'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import carousel1 from '../img/amcpppllc/carousel1.jpg'
import carousel2 from '../img/amcpppllc/carousel2.jpg'
import carousel3 from '../img/amcpppllc/carousel3.jpg'
import carousel4 from '../img/amcpppllc/carousel4.jpg'
import carousel5 from '../img/amcpppllc/carousel5.jpg'



import blog1 from '../img/amcpppllc/blog1.jpg'
import blog2 from '../img/amcpppllc/blog2.jpg'
import blog3 from '../img/amcpppllc/blog3.jpg'
import blog4 from '../img/amcpppllc/blog4.jpg'




import review1 from '../img/amcpppllc/review1.png'
import review2 from '../img/amcpppllc/review2.png'
import review3 from '../img/amcpppllc/review3.png'
import review4 from '../img/amcpppllc/review4.png'




import CTA from './CTA';
import ContactForm from './GetInTouch';


function AMCPAPLLC() {


    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 10000,
        arrows: false,
    };





    const images = [
        carousel1,
        carousel2,
        carousel3,
        carousel4,
        carousel5,

    ];

    const carouselText = [
        "At AM CPA, PLLC, a valued part of SBA Tax Consultancy, we focus on simplifying complex financial matters through our assurance and attestation expertise—helping clients achieve absolute clarity and trust",

        "We are excited to announce that SBA Tax Consultants now operates under our newly registered subsidiary, AM CPA PLLC.",

        "This subsidiary is controlled by the same partners and is officially recognized by the Texas State Board of Public Accountancy as a licensed CPA firm.",

        "Along with our existing services at SBA, AM CPA PLLC now offers Audit and Attestation Services.",

        "These services ensure accurate, reliable financial reporting and compliance for your business."


    ]



    const Services = [
        {
            icon: "bi bi-linkedin",
            heading: "Attestation and Other Engagements",
            text: " We assist organizations in navigating complex regulatory requirements."
        },
        {
            icon: "bi bi-briefcase",
            heading: "Audit Reviews & Compilations",
            text: "Ensuring accurate financial reporting with thorough reviews and compilations tailored to your business needs."
        },
        {
            icon: "bi bi-bar-chart",
            heading: "Employee Benefit Plan Audits",
            text: "Helping businesses comply with regulatory requirements for employee benefit plans with precise and efficient audit services."
        },
        {
            icon: "bi bi-shield-lock",
            heading: "SOC Reporting",
            text: "Assisting organizations in demonstrating the effectiveness of their internal controls with SOC 1, SOC 2, and SOC 3 reports."
        },
        
    ];








    const industrySettings = {
        speed: 5000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: "linear",
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        swipe: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],

    };



    const industryItems = [
        { name: "Financial Services", icon: "bi-graph-up" },
        { name: "Hospitality", icon: "bi-bag-check" },
        { name: "Private Equity /Venture Capital", icon: "bi-bar-chart-line" },
        { name: "Technology & Media and Entertainment", icon: "bi-laptop " },
        { name: "Healthcare and Pharma", icon: "bi-clipboard-plus" },
        { name: "Manufacturing and Distribution", icon: "bi-truck" },   
    ];









    const blogSettings = {
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: "ease-in-out",
        infinite: true,
        slidesToShow: 3, // 3 on desktop
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 768, // Tablets and below
                settings: {
                    slidesToShow: 1, // 1 on mobile
                },
            },
        ],
    };





    const blogItems = [
        {
            image: blog1,
            title: "Maximize Your Business Growth",
            description: "Discover the latest strategies to expand and scale your business efficiently.",
        },
        {
            image: blog2,
            title: "Financial Planning for Startups",
            description: "Learn essential financial planning tips to ensure a strong business foundation.",
        },
        {
            image: blog3,
            title: "Tech Innovations in 2025",
            description: "Explore the newest trends in technology that are shaping the future.",
        },
        {
            image: blog4,
            title: "Digital Marketing Strategies",
            description: "Boost your online presence with proven digital marketing techniques.",
        },

    ];


    const reviewItem = [
        {
            image: review1,
            name: "John Doe",
            message: "Excellent service! The team was professional and helped me scale my business effortlessly.",
        },
        {
            image: review2,
            name: "Emily Smith",
            message: "Their financial advice was a game changer for my startup. Highly recommended!",
        },
        {
            image: review3,
            name: "Michael Johnson",
            message: "Great insights on the latest tech trends. I learned a lot about upcoming innovations.",
        },
        {
            image: review4,
            name: "Sophia Williams",
            message: "Their digital marketing strategies significantly boosted my online presence. Loved it!",
        },
    ];
    







    return (
        <>


            {/* ------------------Slider with text start------------------*/}
            <div className="carousel-container w-100 m-auto amc-slider" >
                <Slider {...settings}>
                    {images.map((img, index) => (
                        <div key={index} className="position-relative ">
                            <img className='banner-slider-img' src={img} alt={`Slide ${index + 1}`} style={{ width: "100%", }} />

                            <div className="overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center">
                                {/* <h3 className="text-white fw-bold">Slide {index + 1}</h3> */}
                                <div className="text-white w-75 ">
                                    <h3 className="fw-bold lh-base">{carouselText[index % carouselText.length]}</h3>
                                </div>

                            </div>
                        </div>
                    ))}
                </Slider>
            </div>


            {/* ------------------Some pharagraph------------------*/}




            <div className="bg-secondary-light outer-text" >
                <h1 className='py-3 h1 primary-text fw-bold'>Heading</h1>
                <p className=''>


                    We are also excited to inform you that SBA Tax Consultants operates under our newly registered subsidiary, controlled by the same partners, AM CPA PLLC, officially recognized by the Texas State Board of Public Accountancy as a licensed CPA firm.
                    In addition to our existing services at SBA, AM CPA PLLC is now offering Audit and Attestation Services to help your business with accurate, reliable financial reporting and compliance.
                </p>

            </div>



            {/* ------------------Founder talks------------------*/}


            {/* <div className="founder-section">
                <h1 className='py-3 h1 primary-text fw-bold founder-word'>Founder</h1>
                <div className="founder d-flex flex-column flex-md-row">


                    <img className='img-fluid rounded border shadow h-100' src={require('../img/ak-merchant-green-updated.webp')} alt="Founder-Image" height={200} />


                    <div className='founder-text'>

                        <div>
                            <p className='fs-3 fw-medium'>Akshay Merchant</p>
                            <p className='fs-6 text-primary'>Chief Operations Officer</p>
                        </div>


                        <p>
                            Get addicted towards your passion in such a way, that life's unpredictable turning challenges will become your stepping stones towards your success. More than two decades of consistent performance has helped us to achieve the right place.
                        </p>


                        <div>

                            <p className='fw-semibold'>Qualification:</p>
                            <p className='text-warning fw-medium'>CPA, CMA, EA, CSCA, CA (India), ACCA (UK), FIII, M. Com & BMS</p>
                        </div>


                        <p>
                            A successful individual, adept in analytical and creative thinking, navigates challenges with strategic precision. Their motivation and self-awareness serve as catalysts, driving not only personal growth but inspiring teams to excel.
                        </p>

                        <a href="https://www.linkedin.com/authwall?trkInfo=AQHV3nX7Nw13HAAAAZT5DhAgixiJUYJXIyRb0gsPWwY6PO4HeLr_qdUmeQ5PioV-uDoOJ-Wa7Cc3PpZ9_IQVtBQVVCghGBbzeMF96QRQtdg_3MxHH_znzEapPHB1c7QstDqSxIY=&original_referer=http://localhost:3000/&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fin%2Fca-akshay-merchant%2F">
                            <i className="bi bi-linkedin" style={{ color: "#0A66C2", fontSize: "24px" }}></i>
                        </a>

                    </div>


                </div>
                <div className="extra-founde-text">
                    <p>
                        Akshay Merchant is having 10+ years of industry experience, serving various clients and has worked in listed companies in India. And he is also the youngest professor in 7 colleges. In the last 9 years, he taught more than 6000+ students. Currently he is teaching CMA, CPA, EA and ACCA students.

                    </p>
                    <p>

                        His simple communication and explaining skills has helped many clients to optimise business finance planning and also helped students clearing competitive exams.
                    </p>
                    <p>


                        His financial planning and analysis achieved remarkable milestones that helped to solve many compliance problems. His expertise steered businesses to fiscal success, ensuring sustainable growth.
                    </p>


                </div>
            </div> */}



            {/* -------------------- Our services -------------------*/}

            <h1 className='py-3 h1 primary-text fw-bold service-head'>Our services </h1>


            <div className="d-flex flex-wrap service">



                <div className="container">
                    <div className="row g-4">
                        {Services.map((item, index) => (
                            <div key={index} className="col-md-4 col-sm-6">
                                <div className="card service-card  shadow-lg border-0 p-4 text-center d-flex flex-column justify-content-between h-100">
                                    <i className={item.icon} style={{ fontSize: "35px", color: "#0A66C2" }}></i>
                                    <h5 className="mt-3 fw-bold">{item.heading}</h5>
                                    <p className="text-muted">{item.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>


                {/* <div className="container">
                    <div className="row g-4 ">
                        {Services.map((item, index) => (
                            <div key={index} className="col-md-4 col-sm-6">
                                <div className="card service-card shadow-lg border-0 p-4 d-flex flex-row h-100">
                                    <i className={item.icon} style={{ fontSize: "35px", color: "#0A66C2" }}></i>
                                    <div className="ms-3">
                                        <h5 className="fw-bold">{item.heading}</h5>
                                        <p className="text-muted">{item.text}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div> */}




            </div>




            {/* --------------- Industry Section -------------- */}

            <h1 className='primary-text fw-bold industry-head'>
                Industries We Serve
            </h1>


            {/* <div className="marquee-container">
                <Slider {...industrySettings}>
                    {industryItems.map((item, index) => (
                        <div key={index} className="card-industry d-flex flex-column align-items-center justify-content-center shadow-sm " >
                            <div className="icon-container d-flex align-items-center justify-content-center">
                                <i className={`bi ${item.icon} text-primary fs-2`}></i>
                            </div>
                            <h6 className="mt-3 fw-bold text-center">{item.name}</h6>
                        </div>
                    ))}
                </Slider>
            </div> */}



            <div className="industry marquee-container container-fluid py-4">
                <Slider {...industrySettings}>
                    {industryItems.map((item, index) => (

                        <div
                            key={index}
                            className="card-industry d-flex flex-column align-items-center justify-content-center shadow-sm"
                            style={{ width: "200px", height: "200px" }}
                        >
                            <div className="icon-container d-flex align-items-center justify-content-center">
                                <i className={`bi ${item.icon} text-primary fs-2`}></i>
                            </div>
                            <h6 className="mt-3 fw-bold text-center">{item.name}</h6>
                        </div>


                    ))}
                </Slider>
            </div>





            {/* --------------- CTA Section -------------- */}


            <CTA />



            {/* ------------- Blogs   ------------- */}

            <h1 className="primary-text fw-bold industry-head">Latest Blogs</h1>
            <div className="blogs-sections py-5">
                <Slider {...blogSettings}>
                    {blogItems.map((blog, index) => (

                        <div key={index} className="p-3">
                            <div className="card shadow-lg border-0 h-100 d-flex flex-column" style={{ minHeight: "400px" }}>
                                {/* Fixed-size image container (Square) */}
                                <div className="overflow-hidden" style={{ height: "150px" }}   >
                                    <img src={blog.image} className="w-100 h-100 object-fit-cover rounded-top" alt={blog.title} />
                                </div>

                                {/* Card Body with Defined Height */}
                                <div className="card-body text-center d-flex flex-column justify-content-between flex-grow-1">
                                    <h5 className="fw-bold">{blog.title}</h5>
                                    <p className="text-muted flex-grow-1">{blog.description}</p>
                                    <a href="#" className="btn btn-primary mt-2">Read More</a>
                                </div>
                            </div>
                        </div>




                    ))}
                </Slider>
            </div>





            {/* ------------- Testimonials   ------------- */}

            <h1 className="primary-text fw-bold industry-head">What people says</h1>
            <div className="blogs-sections py-5">
                <Slider {...blogSettings}>
                    {reviewItem.map((review, index) => (

                        <div key={index} className="p-3">
                            <div className="card shadow-lg border-0 text-center p-3">
                                <div className="mx-auto rounded-circle overflow-hidden border border-2" style={{ width: "150px", height: "150px" }}>
                                    <img src={review.image} className="w-100 h-100 object-fit-cover" alt={review.title} />
                                </div>
                                <div className="card-body">
                                    <h5 className="fw-bold">{review.name}</h5>
                                    <p className="text-muted">{review.message}</p>
                                </div>
                            </div>
                        </div>




                    ))}
                </Slider>
            </div>









            {/* ---------- contact form section --------- */}

            <h1 className="primary-text fw-bold industry-head">Contact Us</h1>

            <ContactForm/>


        </>
    )
}

export default AMCPAPLLC



